import { Component, OnInit, ViewChild } from '@angular/core';
import { NewInspectionService } from '../services/new-inspection.service';
import { ModelSelectionOptionViewModel, InspectionTypeConfigurationViewModel, CompartsOnModelViewModel, InspectionTypeMeasurementPointViewModel } from '../models/create-inspection.model';
import { LoadingService } from '../../../shared/services/loading.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppService } from '../../../app.service';
import { NotificationsService } from 'angular2-notifications';
import { MatSelectionList } from '@angular/material/list';

@Component({
  selector: 'app-manage-inspection-type',
  templateUrl: './manage-inspection-type.component.html',
  styleUrls: ['./manage-inspection-type.component.scss']
})
export class ManageInspectionTypeComponent implements OnInit {

  @ViewChild('inspectionTypesSelectionList')
  inspectionTypesSelectionList: MatSelectionList;

  selectedModel: ModelSelectionOptionViewModel;
  ropeShovelModels: ModelSelectionOptionViewModel[];
  inspectionTypes: InspectionTypeConfigurationViewModel[];

  selectedInspectionType: InspectionTypeConfigurationViewModel;

  selectedComponent: CompartsOnModelViewModel;

  InspectionTypeNameControl: FormControl;
  fg: FormGroup;
  canAddNew = true;
  saving = false;
  inspectionTypeLoading= false;
  originalCopyOfInspectionTypes:  InspectionTypeConfigurationViewModel[];

  constructor(
    private _inspectionService: NewInspectionService,
    private _loading: LoadingService,
    private _appService: AppService,
    private _notify: NotificationsService
    ) { }

  ngOnInit() {
    this._appService.setPageTitle('Manage Inspection Type');
    this._loading.startLoading();
    //this.inspectionTypesSelectionList.selectedOptions = new SelectionModel<MatListOption>(false);
    this.inspectionTypes = [];
    this._inspectionService.getAllRopeShovelModels().subscribe(r => {
      this.ropeShovelModels = r;
      this._loading.finishedLoading();
    });


    this.InspectionTypeNameControl = new FormControl('', [
      Validators.required,
    ]);
    this.fg = new FormGroup({
      InspectionTypeNameControl: this.InspectionTypeNameControl,
    });
  }

  selectedModelChanged(event) {
    if (this.selectedModel === undefined || this.selectedModel.Id !== event.value.Id) {
      this.selectedModel = event.value;
      this.inspectionTypeLoading = true;
      this._inspectionService.getInspectionTypesByModelId(this.selectedModel.Id).subscribe((r:InspectionTypeConfigurationViewModel[]) => {
        this.inspectionTypes = r;
        console.log("Inspection types", this.inspectionTypes)
        this.inspectionTypeLoading = false;
        if ( r.length > 0 ){
          this.inspectionTypes[0].SelectType=true;
          this.selectInspectionTypesChanged(r[0]);
        }
          
          else {
            this.selectedInspectionType = undefined;
          }
      });
    }
  }


  AddNewInspectionType() {
    this.selectedInspectionType = new InspectionTypeConfigurationViewModel();
    this.selectedInspectionType.InspectionTypeName = 'New Inspection type';
    this.selectedInspectionType.InspectionTypeId = 0;
    this.inspectionTypes.push(this.selectedInspectionType);
    this.canAddNew = false;
    this._inspectionService.getNewInspectionTypeTemplate(this.selectedModel.Id).subscribe((m: CompartsOnModelViewModel[]) => {
      console.log(m);
      this.selectedInspectionType.CompartsViewModels = m;
      this.selectFirstMP();
    });
  }


  selectFirstMP() {

    if (this.selectedInspectionType.CompartsViewModels.length > 0)
        this.selectedComponent = this.selectedInspectionType.CompartsViewModels[0];

  }

  selectInspectionTypesChanged(inspectionType: InspectionTypeConfigurationViewModel) {
     console.log(inspectionType);
     inspectionType.SelectType=true;
     this.inspectionTypes.map(x=>{
       if(x.InspectionTypeId==inspectionType.InspectionTypeId){
         x.SelectType=true;
       }else{
         x.SelectType=false;
       }
     })
    this.selectedInspectionType = inspectionType;
    this.selectedInspectionType.InspectionTypeId = inspectionType.InspectionTypeId;

    if (inspectionType.InspectionTypeId == 0) return;
    this._loading.startLoading();
    this._inspectionService.getInspectionTypeByInspectionTypeId(inspectionType.InspectionTypeId).subscribe(s => {
      this.selectedInspectionType = s;
      if (s.CompartsViewModels.length > 0) {
        this.selectFirstMP();
      }
      this._loading.finishedLoading();
    });
  }


  selectComponent(component: CompartsOnModelViewModel, list) {
    this.selectedComponent = component;
  }


  shouldHaveCheckOnThisComponent(component: CompartsOnModelViewModel) {
    const shouldSkipCount = component.MeasurementPoints.filter(x => x.ShouldSkipDuringInspection === false);
    if (shouldSkipCount.length === 0)
      return false;
    return true;
  }

  clickedMP(measurementP: InspectionTypeMeasurementPointViewModel) {
    measurementP.ShouldSkipDuringInspection = !measurementP.ShouldSkipDuringInspection;
    this.shouldHaveCheckOnThisComponent(this.selectedComponent);
  }




  onSelectComponent(event) {
    event.option.selected = this.shouldHaveCheckOnThisComponent(event.option.value);
  }

  SaveChanges() {
    console.log(this.inspectionTypes);
    this.saving = true;
    this._loading.startLoading();
    this._inspectionService.saveInspectionTypeConfig(this.selectedInspectionType).subscribe(result => {
      console.log(result);
      if (result.m_Item1 >= 0) {
        if (this.selectedInspectionType.InspectionTypeId === undefined || this.selectedInspectionType.InspectionTypeId === 0) {
          this.canAddNew = true;
          this.selectedInspectionType.InspectionTypeId = result.m_Item2;
        }
        this._notify.success(`Saved Inspection type ${this.selectedInspectionType.InspectionTypeName} successfully`);
      } else {
        this._notify.error(`Failed to Save Inspection type ${this.selectedInspectionType.InspectionTypeName}`);
      }
      this._loading.finishedLoading();
      this.saving = false;
    });
  }

  CancelAllChanges() {
    if (this.selectedInspectionType.InspectionTypeId === undefined || this.selectedInspectionType.InspectionTypeId === 0) {
      this.inspectionTypes = this.inspectionTypes.filter(i => i !== this.selectedInspectionType);
    }    else {
      this.inspectionTypes = this.originalCopyOfInspectionTypes;
    }

    if (this.inspectionTypes.length > 0) {
      this.selectedInspectionType = this.inspectionTypes[0];
      this.selectFirstMP();
    }  else {
      this.selectedComponent = undefined;
    }
    this.canAddNew = true;
  }
}
